export default __webpack_public_path__ + "static/media/dn.713a8191.png";